// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1UnfA","footer":"ModalError_footer__Xi3up"};